var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "15%", height: "60%" },
          attrs: {
            title: _vm.title,
            width: 800,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _vm.isReadOnly
                ? _c(
                    "a-button",
                    { key: "back", on: { click: _vm.handleCancel } },
                    [_vm._v("\n        取消\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form, id: "roleModal" } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "角色名称",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["name", _vm.validatorRules.name],
                            expression: "[ 'name', validatorRules.name]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入角色名称" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "数据类型",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["type", _vm.validatorRules.type],
                              expression: "[ 'type', validatorRules.type]",
                            },
                          ],
                          staticStyle: { width: "94%" },
                          attrs: { placeholder: "请选择数据类型" },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { value: "全部数据" } },
                            [_vm._v("全部数据")]
                          ),
                          _c(
                            "a-select-option",
                            { attrs: { value: "本部门数据" } },
                            [_vm._v("本部门数据")]
                          ),
                          _c(
                            "a-select-option",
                            { attrs: { value: "个人数据" } },
                            [_vm._v("个人数据")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title:
                              "1、全部数据-该角色对应的用户可以看到全部单据；2、本部门数据-该角色对应的用户可以看到自己所在部门的全部单据；\n              3、个人数据-该角色对应的用户只可以看到自己的单据。单据是指采购入库、销售出库等",
                          },
                        },
                        [
                          _c("a-icon", {
                            staticStyle: {
                              width: "6%",
                              "padding-left": "5px",
                              "font-size": "18px",
                            },
                            attrs: { type: "question-circle" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "价格屏蔽",
                      },
                    },
                    [
                      _c("j-select-multiple", {
                        staticStyle: { width: "94%" },
                        attrs: {
                          placeholder: "请选择价格屏蔽",
                          options: _vm.priceLimitList.options,
                        },
                        model: {
                          value: _vm.priceLimitList.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.priceLimitList, "value", $$v)
                          },
                          expression: "priceLimitList.value",
                        },
                      }),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title:
                              "价格屏蔽支持多选，可以对首页和单据进行价格屏蔽，还可以对商品库存和进销存统计报表进行成本价屏蔽",
                          },
                        },
                        [
                          _c("a-icon", {
                            staticStyle: {
                              width: "6%",
                              "padding-left": "5px",
                              "font-size": "18px",
                            },
                            attrs: { type: "question-circle" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "备注",
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "description",
                              _vm.validatorRules.description,
                            ],
                            expression:
                              "[ 'description', validatorRules.description ]",
                          },
                        ],
                        attrs: { rows: 1, placeholder: "请输入备注" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "排序",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["sort"],
                            expression: "[ 'sort' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入排序" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }